import { Plus } from '@phosphor-icons/react';
import { css, html } from 'react-strict-dom';
import { Text } from 'src/components';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';

type Props = {
  label: string;
  /** Card level sits at 16px, level with the section headings; project level
   * steps in to 36px, level with the order blocks under that project. */
  level: 'project' | 'card';
  onClick: () => void;
};

/** The one thing you can add, at the level it belongs to. */
export default function ProjectsAction({ label, level, onClick }: Props) {
  return (
    <html.div
      style={[Style.row, Style.alignCenter, styles.action, styles[level]]}
    >
      <html.button
        style={[Style.row, Style.alignCenter, styles.link]}
        onClick={onClick}
      >
        <Plus size={14} weight="bold" color={color.accent} />
        <Text typeface="caption.semiBold" color="accent">
          {label}
        </Text>
      </html.button>
    </html.div>
  );
}

const styles = css.create({
  action: {
    paddingRight: 16,
  },
  project: {
    paddingLeft: 36,
    paddingTop: 4,
    paddingBottom: 12,
  },
  card: {
    paddingLeft: 16,
    paddingTop: 6,
    paddingBottom: 12,
  },
  link: {
    gap: 4,
    padding: 0,
    borderWidth: 0,
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
});
